import React from 'react';
import { LogOptions, MetricData, SessionStatsData } from './types';

interface SendLogFunc<T> {
    (log: T): Promise<void> | void;
}

interface Logger {
    trace: SendLogFunc<LogOptions>;
    debug: SendLogFunc<LogOptions>;
    info: SendLogFunc<LogOptions>;
    warn: SendLogFunc<LogOptions>;
    error: SendLogFunc<LogOptions>;
    stats: SendLogFunc<SessionStatsData>;
    metric: SendLogFunc<MetricData>;
    setEnabled: (enabled: boolean) => void;
}

const LoggingContext = React.createContext<Omit<Logger, 'stats' | 'setEnabled'>>({
    trace: () => {},
    debug: () => {},
    info: () => {},
    warn: () => {},
    error: () => {},
    metric: () => {}
});

const useLoggingContext = () => React.useContext(LoggingContext);

const useLogging = () => {
    const logger = useLoggingContext();

    return { logger };
};

export { Logger, LoggingContext, useLogging };
